export default "__VITE_ASSET__bc15ed64__"